import React from 'react';
import './CartSummary.css';

const CartSummary = ({ cartItems, onRemoveItem }) => {
  if (cartItems.length === 0) {
    return (
      <div className="cart-summary empty">
        <h3>Selected Items</h3>
        <p className="empty-cart-message">No items selected yet</p>
      </div>
    );
  }

  const getQuantityLabel = (item) => {
    // Determine if item is bundled based on quantity values
    // Bundles typically have quantities of 6 or 12
    if (item.quantity === 6 || item.quantity === 12) {
      const bundleSize = item.quantity === 6 ? '6-pack' : '12-pack';
      return `${bundleSize}`;
    } else if (item.quantity > 2) {
      // Custom quantity (nonRadio items)
      return `${item.quantity} units`;
    } else {
      // Individual items (1 or 2)
      return `${item.quantity} ${item.quantity === 1 ? 'unit' : 'units'}`;
    }
  };

  return (
    <div className="cart-summary">
      <h3>Selected Items ({cartItems.length})</h3>
      <div className="cart-items-list">
        {cartItems.map((item, index) => (
          <div key={index} className="cart-item">
            <div className="cart-item-info">
              <span className="cart-item-name">{item.name}</span>
              <span className="cart-item-quantity">
                {getQuantityLabel(item)}
              </span>
            </div>
            <button
              type="button"
              className="cart-item-remove"
              onClick={() => onRemoveItem(item.name)}
              aria-label={`Remove ${item.name}`}
            >
              ×
            </button>
          </div>
        ))}
      </div>
      <div className="cart-summary-footer">
        <strong>Total Items: {cartItems.length}</strong>
      </div>
    </div>
  );
};

export default CartSummary;
